import { useContext } from 'react';
import { AppContext, Context } from './context';

export const useStorage = (): AppContext => useContext(Context);
